const s = {
  name: "EmailBackup",
  dimensions: { width: 40, height: 32 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 32" style="enable-background:new 0 0 40 32;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M3.6,30H24v2H3c-1.7,0-3-1.3-3-3V3c0-1.7,1.3-3,3-3h34c1.7,0,3,1.3,3,3v13h-2V3.2L20,19.3l-2.2-2L3.6,30z
			 M2,3.2v25.5L16.3,16L2,3.2z M36.4,2H3.6l14.8,13.3l1.6,1.4L36.4,2z"/>
		<path class="st0" d="M31,20v3h-2v2h4v-5H31z"/>
		<path class="st0" d="M24,24c0-4.4,3.6-8,8-8s8,3.6,8,8s-3.6,8-8,8S24,28.4,24,24z M32,18c-3.3,0-6,2.7-6,6s2.7,6,6,6
			c3.3,0,6-2.7,6-6S35.3,18,32,18z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as EmailBackup
};
